<template>
    <div>
        <span v-if="!params.node.rowPinned">
            <div v-if="isSubscriptionPayment">
                <div v-if="data.is_renew">Plan Renewed</div>
                <div v-if="!data.is_renew">Plan Subscribed</div>
                <div v-for="sp in data.split_payments">
                    Lodgix <span v-html="sp[0]"></span>
                    <span v-if="data.date_until != null"> extends through {{ data.date_until }}</span>
                </div>
            </div>
            <div v-if="isCommissionPayment">
                Integration Commissions
            </div>
            <div v-if="isPolicyPayment">
                Damage Protection Billing
            </div>
            <div v-if="isVerification">
                Guest Verification Billing
            </div>
            <div v-if="isDetail">
                <i
                    >Commission - Invoice <a :href="invoiceLink">{{ data.meta_reservation_id }}</a> -
                    {{ data.commission }}</i
                >
            </div>
            <div v-if="!isDetail">
                PAYMENT: Credit Card
            </div>
        </span>
        <span v-else><b>Total Paid</b></span>
    </div>
</template>

<script>
    export default {
        computed: {
            isSubscriptionPayment() {
                return this.data.payment_type == 'SUBSCRIPTION';
            },
            isPolicyPayment() {
                return this.data.payment_type == 'POLICY';
            },
            isCommissionPayment() {
                return this.data.payment_type == 'COMMISSION';
            },
            isDetail() {
                return this.data.payment_type == 'DETAIL';
            },
            isVerification() {
                return this.data.payment_type == 'VERIFICATION';
            },
            invoiceLink() {
                return `/app/reservation/edit/invoice/${this.data.meta_reservation_id}`;
            },
        },
        data() {
            return {};
        },
        created() {
            this.data = this.params.data;
        },
        methods: {},
    };
</script>
